<!-- 获取产品 -->
<template>
  <article
    class="product-get"
    :style="{ 'background-image': `url(${bgImage})` }"
  >
    <div class="product-get-wrapper" :style="{ width: width + 'px' }">
      <header
        class="product-get-header"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        {{ title }}
      </header>
      <h4
        class="product-get-subTitle"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 200,
        }"
      >
        {{ subTitle }}
      </h4>
      <footer class="product-get-footer">
        <button
          :loading="loading"
          class="product-get-btn"
          @click="downLoad"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 300,
          }"
          v-if="downLoadBtn && downLoadBtn.label && downLoadBtn.show"
        >
          {{ downLoadBtn.label }}
        </button>
        <button
          class="product-get-btn"
          v-if="contactBtn && contactBtn.label"
          v-scroll-animate="{
            animation: 'fadeInUp',
            delay: 350,
          }"
        >
          {{ contactBtn.label }}
        </button>
      </footer>
    </div>
  </article>
</template>

<script>
import { downLoadFile } from "@/api/api";
export default {
  name: "ProductGet",
  components: {},
  props: {
    title: {
      type: String,
      default: "Infrastructure Operation and Maintenance Digital Twin Solution",
    },
    subTitle: {
      type: String,
      default:
        "Bringing a new model to the operation and maintenance management of roadways, waterways, and city infrastructure!",
    },
    bgImage: {
      type: String,
      default: () => require("@/assets/images/dtwin/getNow_bg.png"),
    },
    downLoadBtn: {
      type: Object,
      default: () => {
        return {
          label: "Download Brochure",
          fileUrl: "",
          show: true,
          action: "downLoad", // link or download
        };
      },
    },
    contactBtn: {
      type: Object,
      default: () => {
        return {
          label: "Let a Sales Representative Contact You",
        };
      },
    },
    width: {
      type: Number,
      default: 1200,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    downLoad() {
      if (this.downLoadBtn.action && this.downLoadBtn.action === "downLoad") {
        if (!this.downLoadBtn.fileUrl) return;
        this.loading = true;
        downLoadFile(this.downLoadBtn.fileUrl)
          .then((res) => {
            let fileName = this.$uniFun.getFileName(this.downLoadBtn.fileUrl);
            this.$uniFun.downloadFile(res, fileName);
          })
          .catch((e) => {
            console.log("err--", err);
            this.$message.error("资源请求错误");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        let url = this.downLoadBtn.fileUrl || "/download?type=software";
        this.$uniFun.openInCurrentTab(url);
      }
    },
  },
};
</script>

<style lang="scss">
.product-get {
  width: 100%;
  height: 240px;
  // background: url("~@/assets/images/dtwin/getNow_bg.png") no-repeat center;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 240px;
  color: #fff;
  .product-get-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 52px 0;
    text-align: center;
  }
  .product-get-header {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
  .product-get-subTitle {
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 18px;
    color: #fff;
    line-height: 27px;
    text-align: justify;
    font-style: normal;
  }
  .product-get-footer {
    text-align: left;
    .product-get-btn {
      padding: 8px 12px;
      font-size: 14px;
      color: #000;
      text-align: center;
      background: #fff;
      border-radius: 2px;
      &:first-child {
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          opacity: 0.8 !important;
        }
      }
    }
  }
}
</style>
